//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('saftMainGroup', {
//        templateUrl: 'views/components/views/saftMainGroup/saftMainGroup.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'saftMainGroupService', 'acVatCodeDataService', function ($stateParams, stateService, translateService, modalService, saftMainGroupService, acVatCodeDataService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let saftMainGroupNo = $stateParams.saft_maingroup_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                saftMainGroupNo: saftMainGroupNo,
//                vatReportGroupsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vatreportgroup_keyno = '0' }
//                ],
//                vatTaxLevelsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vattaxlevel_keyno = '0' }
//                ],
//                edit: {},
//                selectListVatReportGroups: [],
//                selectListVatTaxLevels: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadEdit = function () {
//            	saftMainGroupService.getEdit({ saft_maingroup_no: saftMainGroupNo }).then(function (info) {
//            		angular.copy(info[0], vm.model.edit);
//            	});
//            };

//            let loadVatReportGroups = function () {
//                acVatCodeDataService.listVatReportGroups().then(function (list) {
//                    angular.copy(list, vm.model.selectListVatReportGroups);
//                });
//            };

//            let loadVatTaxLevels = function () {
//                acVatCodeDataService.listVatTaxLevels().then(function (list) {
//                    angular.copy(list, vm.model.selectListVatTaxLevels);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                saftMainGroupService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadEdit();
//                loadVatReportGroups();
//                loadVatTaxLevels();
//            };

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
